// extracted by mini-css-extract-plugin
module.exports = {"row":"flexbox-two-columns_row__jjmeR","reverseColumnOrder":"flexbox-two-columns_reverseColumnOrder__i0F9n","column":"flexbox-two-columns_column__CQtD4"};